import { toast } from "react-toastify";
import moment from "moment";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";

const user = [localStorage.getItem("id"), localStorage.getItem("userName")];

export const mulipleApproveCertificates = async (action, selectedIds = []) => {
  if (!["prepared", "review", "authorized"].includes(action) || selectedIds.length === 0) {
    console.error("Invalid action or no certificate IDs provided");
    return;
  }

  try {
    // Step 1: Get current date from SQL
    const dateQuery = `SELECT NOW() AS date`;
    const dateRes = await axiosWithToken.post(`${BASE_URL}dynamic`, { query: dateQuery });
    const dateTime = dateRes.data?.[0]?.date || moment().format("YYYY-MM-DD HH:mm:ss");
    const formattedDate = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");

    // Step 2: Prepare update query based on action type
    const idsList = selectedIds.join(",");
    let updateQuery = "";

    if (action === "prepared") {
      updateQuery = `UPDATE certificate SET preparedBy = ${Number(user[0])}, preparedDate = '${formattedDate}' WHERE id IN (${idsList})`;
    } else if (action === "review") {
      updateQuery = `UPDATE certificate SET reviewedBy = ${Number(user[0])}, reviewedDate = '${formattedDate}' WHERE id IN (${idsList})`;
    } else if (action === "authorized") {
      updateQuery = `UPDATE certificate SET authorizedBy = ${Number(user[0])}, authorizedDate = '${formattedDate}' WHERE id IN (${idsList})`;
    }

    // Step 3: Execute SQL update
    await axiosWithToken.post(`${BASE_URL}dynamic`, { query: updateQuery });

    // Step 4: Feedback to user
    const actionLabel = action === "review" ? "reviewed" : "authorized";
    toast.success(`Certificates ${actionLabel} successfully!`);

    setTimeout(() => window.location.reload(), 500);
  } catch (error) {
    console.error("Error approving certificates:", error);
    toast.error("Error updating certificates. Please try again.");
  }
};
